import api from '../../../services/service_pos'
import Swal from 'sweetalert2'
export default {
  data () {
    return {
      bill_data: [],
      bill_name: '',
      hostshift: '',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      checkArray: [],
      form_data: ''
    }
  },
  created () {
    this.checkUser()
    if (sessionStorage.hostshift) {
      this.hostshift = JSON.parse(sessionStorage.hostshift)
    } else {
      this.$router.push('/')
    }
  },
  computed: {
    paginate: function () {
      this.totalItem = this.bill_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.bill_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    async onClickSelected (e, row) {
      if (!e.target.checked) {
        this.checkArray = await this.arrayRemove(this.checkArray, row.id)
      }
      let checkData = true
      await this.paginate.map(item => {
        if (item.selected === true) {
          this.bill_name = item.ar_name
          checkData = false
        }
      })
      if (checkData) {
        this.bill_name = ''
      }
      if (this.bill_name === row.ar_name || this.bill_name === '') {
        this.bill_name = row.ar_name
        // row.selected = e.target.checked
        // this.handleSelected()
        this.bill_data = this.bill_data.map(item => {
          if (row.id === item.id && e.target.checked === true) {
            this.checkArray.push(item.id)
            item.selected = e.target.checked
          } else {
            if (this.checkArray.includes(item.id) === true)
            {
              item.selected = true
            } else {
              item.selected = false
            }
          }
          return item
        })
        this.handleSelected()
        if (checkData) {
          this.bill_name = ''
        }
      } else {
        row.selected = false
        e.target.checked = false
      }
    },
    arrayRemove (arr, value) {
      return arr.filter(function (ele) {
        return ele !== value
      })
    },
    handleSelected () {
      if (this.paginate.filter(e => e.selected).length > 0) {
        $('.btn-multiple-checkout').removeClass('btn-secondary disabled cursor-default checkout-disabled')
        $('.btn-multiple-checkout').addClass('btn-success')
      } else {
        $('.btn-multiple-checkout').addClass('btn-secondary disabled cursor-default checkout-disabled')
        $('.btn-multiple-checkout').removeClass('btn-success')
      }
    },
    onClickSelectedAll () {
      // const _selected = this.paginate.filter(e => !e.selected)
      // const isSeleted = _selected && _selected.length > 0
      // this.bill_data = this.paginate.map(item => {
      //   item.selected = isSeleted
      //   return item
      // })
      // $('.table-holding .check-row').prop('checked', isSeleted)
      // this.handleSelected()
    },
    CheckSearch () {
      if (this.search === '') {
        this.onChange(1)
        this.getBillAll()
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getBillAll () {
      this.$store.commit('Loading')
      this.bill_data = []
      this.checkArray = []
      var obj = {
        'host_code': this.hostshift.host_code,
        'keyword': this.search
      }
      api.getHoldingBill(
        this.REST_URL,
        obj,
        this.header,
        async result => {
          if (result.response === 'success') {
            this.bill_data = result.data
            this.bill_data.map(x => {
              x['selected'] = false
            })
          } else {
            this.$notification['warning']({
              message: 'เปิดการขายไม่ได้',
              description: result.message
            })
          }
          this.bill_name = ''
          this.$store.commit('Loading')
          $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal')
          })
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    async checkout (obj) {
      if (!obj) {
        // ชำระหลายรายการ
        this.$store.commit('clearOrderPayment')
        console.log('ชำระหลายรายการ clicked')
        // let data = []
        // let dataSub = []
        await this.bill_data.map(item => {
          if (item.selected === true) {
            item.sub.map((x, c) => {
              var data = {
                'doc_no': item.doc_no,
                'hold_bill_id': item.id,
                'name': x.item_name,
                'unit_code': x.unit_code,
                'item_barcode': x.item_barcode,
                'qty': parseFloat(x.qty),
                'price': parseFloat(x.price),
                'normal_price': parseFloat(x.price),
                'total_amount': parseFloat(x.price * 1),
                'item_data': x,
                'description': '',
                'used': false
              }
              this.$store.state.item_subs.push(data)
            })
          }
        })
        this.$store.state.order_data.item_amount = 0
        this.$store.state.order_data['multiple'] = true
        this.$store.state.item_subs.forEach(val => {
          this.$store.state.order_data.item_amount += parseFloat(val['qty'] * val['price'])
        })
        this.$store.state.order_data.item_amount = Math.ceil(this.$store.state.order_data.item_amount)
        // this.$store.state.order_data = data[0]
        // this.$store.state.item_subs = dataSub[0]
        // this.$store.state.item_subs.push(dataSub[0])

        $('#ToolModal').modal('hide')
        $('body').on('hidden.bs.modal', '.modal', function () {
          $(this).removeData('bs.modal')
        })
      } else {
        this.$store.state.order_data = obj
        this.$store.state.item_subs = obj.sub
        this.$store.state.order_data['multiple'] = false
        $('#ToolModal').modal('hide')
        $('body').on('hidden.bs.modal', '.modal', function () {
          $(this).removeData('bs.modal')
        })
      }
    },
    cancelBill (data) {
      $('#ToolModal').modal('hide')
      Swal.fire({
        title: 'ยกเลิกบิล',
        text: 'ท่านต้องการยกเลิกบิลขายเลขที่ ' + data.doc_no + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ปิด'
      }).then((res) => {
        if (res.value) {
          this.$store.commit('Loading')
          var obj = {
            'doc_no': data.doc_no
          }
          api.cancelBill(this.REST_URL,
            obj,
            this.header,
            result => {
              if (result.response === 'success') {
                this.$notification['success']({
                  message: 'ยกเลิกบิล',
                  description: 'ยกเลิกบิลเรียบร้อย'
                })
                this.search = ''
              } else {
                this.$notification['warning']({
                  message: 'ยกเลิกบิล',
                  description: 'ยกเลิกบิลไม่สมบูรณ์'
                })
              }
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
              this.$store.commit('Loading')
            },
            error => {
              $('#ToolModal').modal('show')
              this.$store.commit('Loading')
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        } else {
          $('#ToolModal').modal('show')
        }
      })
    },
    printHoldingBill (docNo) {
      var obj = {
        'printer_port': this.hostshift.printer_port,
        'doc_no': docNo
      }
      api.printHolding(this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'พิมพ์ใบพักบิลยอดสำเร็จ',
              description: result.message
            })
            this.form_data = JSON.stringify(result.data)
            setTimeout(() => {
              this.$refs.printInvioce.submit()
              this.$store.commit('Loading')
              $('#ToolModal').modal('hide')
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
            }, 1000)

            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบพักบิลไม่ได้',
              description: result.message
            })

            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          $('body').on('hidden.bs.modal', '.modal', function () {
            console.clear()
            $(this).removeData('bs.modal')
          })
        }
      )
    },
    printHoldingPDF (obj) {
      this.$store.commit('Loading')
      api.billCreditDetail(this.REST_URL,
        this.header,
        { doc_no: obj.doc_no },
        result => {
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data);
            setTimeout(() => {
              this.$refs.printHolding.submit()
              this.$store.commit('Loading')
              $('#ToolModal').modal('hide')
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
            }, 1000)
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบแจ้งยอดไม่ได้',
              description: result.message
            })
            $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal')
            })
            this.$store.commit('Loading')
          }
        },
        error => {
          $('#ToolModal').modal('show')
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        })
    },
    openDetailBill (val) {
      console.log(val)
      this.$store.state.detail_pop = val
      $('#itemDetailBill').modal('show')
    }
  },
  mounted () {
    $('#ToolModal').on(
      'show.bs.modal',
      function () {
        this.search = ''
        this.getBillAll()
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/bill_holding_list.js